import React from 'react';
import { WhitePanel } from '../../../../components';
import config from '../../../../config';

export default function ImportantNotice() {
  return (
    <WhitePanel className="mb-4">
      <h2>IMPORTANT NOTICE </h2>
      <p>
      Due to flight congestion at Kathmandu’s International Airport, all flights to and from Lukla has been redirected to Manthali Airport at Ramechhap by the Civil Aviation Authority of Nepal.</p>
      
      <p>SPECIAL NOTE:
        <ol className="imp-note">
          <li>
            Manthali Airport, Ramechhap is 4-5 hour drive from Kathmandu. While the drive is a bit of a hassle, chances of delays and cancellations from Manthali Airport is very low as the only air traffic from that airport is to/from Lukla. We arrange transportation between Ramechhap and Kathmandu as well.
          </li>
        </ol>
      </p>
      <br />
      <p>
        Contact:{' '}
        <a
          target="_blank" rel="noopener noreferrer"
          href={`mailto:${config.honeyguideEmail}`}
          style={{ color: '#00C0FF' }}
        >
          {config.honeyguideEmail}
        </a>{' '}
        or Whatsapp{' '}
        <a href={`https://api.whatsapp.com/send?phone=${config.honeyguidePhoneNumber}`} target="_blank" rel="noopener noreferrer" style={{ color: '#00C0FF' }}>
          {config.honeyguidePhoneNumber}
        </a>{' '}
        if you have any questions. <br />
      </p>
    </WhitePanel>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/StaticSections/ImportantNotice.js